import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';


import {
  MSG_SHOW_WARNING_SAVE,
  MSG_HIDE_WARNING_SAVE,
} from '../../../redux/actions/actionTypes'
import styles from './styles'

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose,bgClass } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root + " " + bgClass}>
      <Typography variant="h6" className="msgbox-title" >{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    minWidth:700,
    maxWidth:800,
    textAlign:"center"
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    justifyContent:"center"
  },
}))(MuiDialogActions);


const ExpansionPanel = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: '#cccccc12',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiExpansionPanelDetails);

export function CustomizedExpansionPanels(props) {
  const { data } = props;
  var firstRow = 1;
  if(Object.keys(data).length===1)
    firstRow=Object.keys(data)[0]
  const [expanded, setExpanded] = React.useState('panel'+firstRow);

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  function renameTitle (keyTable){
    var keyNew=keyTable;
    switch(keyTable){
        case "T_GR_DETAIL":keyNew='แท็บข้อมูล GR ';break
        case "T_GR_ITEM":keyNew='แท็บข้อมูล GR รายการรับสินค้า  ';break
        case "T_GR_ITEM_ACCOUNT_ASSIGNMENT":keyNew='แท็บข้อมูล GR รายการรับสินค้า Account Assignment ';break
        case "T_GR_SERVICE":keyNew='แท็บข้อมูล GR รายการรับบริการ  ';break
        case "T_GR_SERVICE_LINE":keyNew='แท็บข้อมูล GR รายการ Service Line ';break
        case "T_GR_SERVICELINE_ACCOUNT_ASSIGNMENT":keyNew='แท็บข้อมูล GR รายการรับบริการ Service Line Account Assignment ';break
        case "T_IR_DETAIL":keyNew='แท็บข้อมูล IR  ';break
        case "T_IR_ITEM":keyNew='แท็บข้อมูล IR รายการรับสินค้า - บริการ  ';break
        case "T_MR_DETAIL_MOM":keyNew='แท็บข้อมูล ผลการตรวจรับ  ';break
        case "T_MR_DETAIL":keyNew='แท็บข้อมูล MR  ';break
    }
    return keyNew
  }

  return (
    <div>
    {data && Object.keys(data).map((row, index) => {
      return(
        <ExpansionPanel  expanded={expanded === 'panel'+row} onChange={handleChange('panel'+row)}>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id={"panel1bh-header"+row}
          >
            <div className="row" style={{justifyContent:"center",width:"100%",paddingLeft:80}}>
              <Typography>{renameTitle(row)}</Typography>
              <div className="msgNumber">
              {data[row].length}
              </div>
            </div>
           
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Typography style={{width:"100%",backgroundColor:"#fffefc"}}>
                {data[row] && Object.keys(data[row]).map((row2, index2) => {
                  return(
                    <div>
                      <div className="rrs-label" style={{"text-align":"left","margin-left":"10%",fontSize:15}}>
                        {data[row][row2]}
                      </div>
                    </div>
                  )})}
            </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      )})
    }
    </div>
  );
}



class MsgBoxSaveContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen:false,
      msgType:null,
      title:null,
      message:null,
      nexttab:null
    }

    const showWarning=this.showWarning.bind(this)

    this.handleClose=this.handleClose.bind(this)

    window.emitter.addListener(MSG_SHOW_WARNING_SAVE, function(message) {
      
      showWarning(message)
    })
    window.emitter.addListener(MSG_HIDE_WARNING_SAVE, this.handleClose.bind(this))
  }

showWarning(message){
  this.setState({
    isOpen:true,
    title:"Error",
    message:message,
    nexttab:null
  })
 }
 
  handleClose() {
    console.log("handleClose()")
    this.setState({ isOpen: false })
  }

   render() {  
     let { isOpen, msgType, title, message, nexttab } = this.state
     let target = ""
     if (nexttab) {
       target = "#" + nexttab
     }


    return(
      <div style={{zIndex:999999}}>
        <Dialog  id="msgBoxContainer" maxWidth={700} onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={isOpen}>
        
          <DialogTitle id="customized-dialog-title" bgClass="bg-danger" onClose={this.handleClose}>
            {title}
          </DialogTitle>
          <DialogContent dividers>
              <CustomizedExpansionPanels data={this.state.message}/>
          </DialogContent>
          <DialogActions>
            <a href="#" className="sp-btn-icon btn-ok" data-toggle="collapse" data-target={target} aria-expanded="false" aria-controls={nexttab} onClick={this.handleClose}  >
              <i className="icon btn-order-check-green" />
              <span className="sp-btn-icon-label">ตกลง</span>
            </a>
          </DialogActions>
          
        </Dialog>
  </div>
    )
  }
}

export default MsgBoxSaveContainer
